<template>
  <!-- Regions -->
  <div v-if="regions && regions.length > 0" class="input-select-container">
    <!-- <label for="region-filter">{{ $t('spots.filter_title_regions') }}:</label> -->
    <select
      name="region-filter"
      id="region-filter"
      class="input-select"
      v-model="selectedRegionId"
      @change="updateValue($event)"
    >
      <option :value="0">{{ $t('spots.filter_text_all_regions') }}</option>
      <option v-for="region in regions" v-bind:value="region.id">
        {{ region.name }}
      </option>
    </select>
  </div>
</template>
<script setup lang="ts">
const emit = defineEmits(['update:modelValue']);
const platformSettings = usePlatformSettings();
const selectedRegionId = platformSettings.region;
const { $api } = useNuxtApp();

const { data: regions } = await useAsyncData(
  'regions',
  async () => {
    return await $api<Region[]>('regions');
  },
  { watch: [platformSettings.countryCode] }
);

function updateValue(event: Event) {
  const value = (event.target as HTMLSelectElement).value;
  // get number value from string
  const numberValue = parseInt(value);

  platformSettings.setRegion(numberValue);
  emit('update:modelValue', value);
}
</script>
